module.exports = __webpack_public_path__ + "static/img/badge-adulticide-inactive.2786a07.svg";